import { func, string, bool } from "prop-types";

import React from "react";
import TextAndButtonsModal from "./TextAndButtonsModal";

const ConfirmDialog = ({
    showDialog,
    onCancel,
    onConfirm,
    title,
    description,
    confirmLabel,
    modalId,
    loading,
    textClassName,
}) => (
    <div className="modal-container">
        <TextAndButtonsModal
            modalShow={showDialog}
            acceptFunction={onConfirm}
            cancelFunction={onCancel}
            headingText={title || ""}
            text={description || ""}
            confirmLabel={confirmLabel}
            modalId={modalId}
            loading={loading}
            textClassName={textClassName}
        />
    </div>
);

ConfirmDialog.propTypes = {
    showDialog: bool,
    onCancel: func,
    onConfirm: func,
    title: string,
    description: string.isRequired,
    confirmLabel: string,
    modalId: string,
    loading: bool,
    textClassName: string,
};
ConfirmDialog.defaultProps = {
    showDialog: false,
    onCancel: undefined,
    onConfirm: undefined,
    title: "",
    confirmLabel: "global.accept",
    modalId: undefined,
    loading: false,
    textClassName: "mx-md-12",
};

export default ConfirmDialog;
